module.exports = __webpack_public_path__ + "static/media/ic_no-image.b06e01da.svg";